import {Chapter} from '../../models/Chapter';
import {Block} from '../../models/Block';
import {Expander} from '../../business/expanded_parts/Expander';

export function chaptersToApiChapters(
    blocks: Block[],
    chapters: Chapter[],
): Array<{part_index: number; title: string; thumbnail_url: string | null}> {
    const expandedParts = new Expander().expand(blocks);
    return chapters.map((chapter) => ({
        part_index: expandedParts.findIndex((expandedPart) => expandedPart.__uuid === chapter.__expandedPartUuid),
        title: chapter.title,
        thumbnail_id: chapter.thumbnail_id,
        thumbnail_url: chapter.thumbnail_url,
    }));
}
